import BasicModal from 'components/modal/basic-modal'
import { local, setlocal } from 'data/lib/local-json'
import Client from 'data/_client'
import { BellExclamation } from 'images/icons/header'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import Isvg from 'react-inlinesvg'
import styled from 'styled-components'
import { Colors } from 'styles/app-styles'

const NotificationHeader = styled.span`
  display: inline-block;
  width: 20px;
  margin-top: 2px;
  margin-right: 17px;
  svg {
    width: 100%;
    height: 100%;
    path {
      fill: ${({hasUnseen}) => hasUnseen ? 'orange' : Colors.blackPearl};
    }
  }
`
export const UL = styled.ul`
  li { padding: 3px; }
  li { background: ${Colors.white}; }
  li:nth-child(odd) { background: ${Colors.lightMystic}; }
`

const NotificationsLanding = styled.div`
  font-family: 'Roboto', sans-serif;
  width: 100%;
  li {
    padding: 10px;
    background: orange;
    border-bottom: 1px solid ${Colors.towerGrey};
  }
`

export const LocalNotificationStore = {
  sync(notifications) {
    if(!_.isArray(notifications)) return
    // merge syncs with user's local
    let current = local('system_notifications', [])
    // remove old otifications
    current = _.filter(current, ({text}) => _.includes(notifications, text))

    // append new notifications mapped to {text, seen}
    const novel = _.filter(notifications, (text) => !_.find(current, {text}))
    const as_seeable = (text) => ({text, seen: false})
    current.push(..._.map(novel, as_seeable))
    setlocal('system_notifications', current)
  },

  all_notifications() {
    return local('system_notifications', [])
  },

  has_notifications() {
    return !!local('system_notifications', []).length
  },

  unseen(){
    let current = local('system_notifications', [])
    return _.filter(current, {seen: false})
  },

  mark_all() {
    let current = local('system_notifications', [])
    _.forEach(current, (notification) => {notification.seen = true})
    setlocal('system_notifications', current)
  },
}

export default class Notifications extends React.Component {
  static propTypes = {
    banner: PropTypes.bool
  }

  state = {
    show: false
  }

  componentDidMount() {
    Client.get(`notifications`)
    .then((xs) => _.map(xs, 'message'))
    .then(LocalNotificationStore.sync)
    .then(() => {
      this.setState({show: !!LocalNotificationStore.unseen().length})
    })
  }

  setSeenAndHide  = () =>{
    LocalNotificationStore.mark_all()
    this.setState({show: false})
  }

  render_header = () => {
    const { show } = this.state
    const hasUnseen = !!LocalNotificationStore.unseen().length
    const empty = !LocalNotificationStore.all_notifications().length
    if (empty) return null
    const items = _.map(hasUnseen ? LocalNotificationStore.unseen() : LocalNotificationStore.all_notifications(), ({text}) => <li>{text}</li>)
    return (
      <NotificationHeader onClick={() => this.setState({show: !show})} hasUnseen={hasUnseen}>
        <Isvg src={BellExclamation}/>
        <BasicModal
          show={show}
          toggleShow={this.setSeenAndHide}
          closeIconWidth={24}
          title={'Notifications'}
          >
            <UL>
              {items}
            </UL>
        </BasicModal>
      </NotificationHeader>
    )
  }

  render() {
    const { banner }  = this.props
    if (banner) {
      const items = _.map(LocalNotificationStore.all_notifications(), ({text}) => <li>{text}</li>)
      if (!items.length) return null
      return <NotificationsLanding><ul>{items}</ul></NotificationsLanding>
    }
    return this.render_header()
  }
}
